import { NotesApps } from "@/components/onboarding/components/ImportWizard/ImportWizard.config";
import { AppId } from "@/components/onboarding/components/ImportWizard/ImportWizard.types";
import {
  Tab,
  TabsContainer,
} from "@/components/onboarding/components/ImportWizard/StyledComponents";

interface Props {
  selectedAppId: string | null;
  onAppSelect: (appId: AppId) => void;
}

export const Tabs: React.FC<Props> = ({ selectedAppId, onAppSelect }) => (
  <TabsContainer>
    {NotesApps.filter(app => !app.omitFromTabs).map(app => (
      <Tab key={app.id} isActive={selectedAppId === app.id} onClick={() => onAppSelect(app.id)}>
        {app.title}
      </Tab>
    ))}
  </TabsContainer>
);
